import { z } from 'zod';
export const UploadPartSchema = z.object({
    partNumber: z.number(),
    signedUrl: z.string(),
});
export const UploadedPartSchema = z.object({
    eTag: z.string(),
    partNumber: z.number(),
});
